import React, { Component } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
export default class CheckableTag extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { checked, onChange } = this.props;
            if (onChange) {
                onChange(!checked);
            }
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { prefixCls: customizePrefixCls, className, checked, ...restProps } = this.props;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('tag', customizePrefixCls);
        const cls = classNames(prefixCls, {
            [`${prefixCls}-checkable`]: true,
            [`${prefixCls}-checkable-checked`]: checked,
        }, className);
        delete restProps.onChange; // TypeScript cannot check delete now.
        return React.createElement("div", Object.assign({}, restProps, { className: cls, onClick: this.handleClick }));
    }
}
CheckableTag.displayName = 'CheckableTag';
